import { Routes, Route, BrowserRouter as Router, Navigate } from "react-router-dom";
import HomePage from "./HomePage";
import About from "./about";
import Services from "./services";
import SchoolSolutions from "./schoolSolutions";
import PMESolutions from "./pmeSolutions";
import Contact from "./contact";
import Portfolio from "./portfolio";
import FAQ from "./faq";
import Blog from "./blog";
import Register from "./register";
import FullpageWrapper from "./FullpageWrapper";
import SamolCaissePage from "./SamolCaissePage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FullpageWrapper />} />
        <Route path="/accueil" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/solutions-ecoles" element={<SchoolSolutions />} />
        <Route path="/solutions-pme" element={<PMESolutions />} />
        <Route path="/nos-realisations" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Navigate to="/nos-realisations" replace />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/register" element={<Register />} />
        <Route path="/samol-caisse" element={<SamolCaissePage />} />
        <Route path="/app" element={<SamolCaissePage />} />
        <Route path="/app/*" element={<SamolCaissePage />} />
        <Route path="/fullpageWrapper" element={<FullpageWrapper />} />
      </Routes>
    </Router>
  );
}

export default App;
